import { Component } from '@angular/core';
@Component({
  selector: 'app-main2',
  templateUrl: './main.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class MainComponent {
  constructor() {}
}
